import React from 'react';
import { NavBar } from '../../Modules/Navigation/components/NavBar/NavBar';
import PageContentCardContainer from '../../ui/Layout/PageContentCardContainer/PageContentCardContainer';
import SongAdmin from '../../Modules/Song/features/SongAdmin/SongAdmin';

const SongAdminPage = () => (
    <>
        <NavBar />
        <PageContentCardContainer>
            <SongAdmin />
        </PageContentCardContainer>
    </>
);

export default SongAdminPage;
